/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The Version of the XSD Schema used in this data. The versions apply to different historical data and are included here for completeness. This value is always \"RdSAP-20.0\".
 */
export type SchemaVersion = 'RdSAP-20.0';

export const SchemaVersion = {
    RdSap200: 'RdSAP-20.0' as SchemaVersion
};

